var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconOrders = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.192,
    height: 14.001,
    viewBox: "0 0 11.192 14.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(-15 -180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M507.768,514.742H497.135a.279.279,0,0,1-.279-.28v-1.4a1.12,1.12,0,0,1,1.119-1.119h8.953a1.121,1.121,0,0,1,1.12,1.119v1.4A.28.28,0,0,1,507.768,514.742Zm-10.5-.388H507.63v-1.421a.654.654,0,0,0-.576-.711h-9.2a.655.655,0,0,0-.576.711Z",
    transform: "translate(-481.856 -331.384)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M499.774,517.3H498.1a.279.279,0,0,1-.28-.28v-1.679a.28.28,0,0,1,.28-.28h1.679a.281.281,0,0,1,.28.28v1.679A.28.28,0,0,1,499.774,517.3Zm-1.637-.323h1.594v-1.592h-1.594Z",
    transform: "translate(-481.697 -330.865)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M504.69,515.861h-4.2a.28.28,0,1,1,0-.56h4.2a.28.28,0,1,1,0,.56Z",
    transform: "translate(-481.297 -330.824)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M506.088,516.82h-5.6a.28.28,0,1,1,0-.56h5.6a.28.28,0,1,1,0,.56Z",
    transform: "translate(-481.297 -330.665)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M499.774,519.938H498.1a.279.279,0,0,1-.28-.28v-1.679a.28.28,0,0,1,.28-.28h1.679a.281.281,0,0,1,.28.28v1.679A.28.28,0,0,1,499.774,519.938Zm-1.637-.323h1.594v-1.592h-1.594Z",
    transform: "translate(-481.697 -330.425)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M504.69,518.5h-4.2a.28.28,0,1,1,0-.56h4.2a.28.28,0,1,1,0,.56Z",
    transform: "translate(-481.297 -330.385)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M506.088,519.458h-5.6a.28.28,0,1,1,0-.56h5.6a.28.28,0,1,1,0,.56Z",
    transform: "translate(-481.297 -330.225)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M499.774,522.576H498.1a.279.279,0,0,1-.28-.28v-1.679a.28.28,0,0,1,.28-.28h1.679a.281.281,0,0,1,.28.28V522.3A.28.28,0,0,1,499.774,522.576Zm-1.581-.378h1.482v-1.482h-1.482Z",
    transform: "translate(-481.697 -329.985)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M504.6,521.137h-4.105a.28.28,0,1,1,0-.56H504.6a.28.28,0,1,1,0,.56Z",
    transform: "translate(-481.297 -329.945)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M503.627,522.1h-3.134a.279.279,0,1,1,0-.559h3.134a.279.279,0,1,1,0,.559Z",
    transform: "translate(-481.297 -329.785)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M498.335,513.423a.279.279,0,0,1-.28-.28v-1.4a.279.279,0,1,1,.559,0v1.4A.279.279,0,0,1,498.335,513.423Z",
    transform: "translate(-481.657 -331.464)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M500.013,513.423a.279.279,0,0,1-.279-.28v-1.4a.279.279,0,1,1,.559,0v1.4A.279.279,0,0,1,500.013,513.423Z",
    transform: "translate(-481.377 -331.464)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M505.05,513.423a.279.279,0,0,1-.28-.28v-1.4a.279.279,0,1,1,.559,0v1.4A.279.279,0,0,1,505.05,513.423Z",
    transform: "translate(-480.537 -331.464)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M503.371,513.423a.279.279,0,0,1-.28-.28v-1.4a.28.28,0,1,1,.56,0v1.4A.28.28,0,0,1,503.371,513.423Z",
    transform: "translate(-480.817 -331.464)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M501.692,513.423a.28.28,0,0,1-.28-.28v-1.4a.28.28,0,0,1,.56,0v1.4A.28.28,0,0,1,501.692,513.423Z",
    transform: "translate(-481.097 -331.464)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M507.166,512.471a.329.329,0,0,1,.329.329v11.716a.329.329,0,0,1-.329.329H497.73a.329.329,0,0,1-.329-.329V512.8a.329.329,0,0,1,.329-.329h9.436m0-.542H497.73a.872.872,0,0,0-.871.872v11.716a.871.871,0,0,0,.871.871h9.436a.871.871,0,0,0,.872-.871V512.8a.872.872,0,0,0-.872-.872Z",
    transform: "translate(-481.856 -331.387)",
    fill: "#173a6d"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconOrders, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_orders.018de1ce.svg";
export { ForwardRef as ReactComponent };